module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG8a221a3707eea39e2c556cc239008dc7.8a221a37.png";